export default __webpack_public_path__ + "947e3b0ab7757e2600b3e5a3e9b5214c.svg";